var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableSelectedBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4707 0.371094H3.0957C2.49897 0.371094 1.92667 0.608147 1.50471 1.0301C1.08276 1.45206 0.845703 2.02436 0.845703 2.62109V14.9961C0.845703 15.5928 1.08276 16.1651 1.50471 16.5871C1.92667 17.009 2.49897 17.2461 3.0957 17.2461H15.4707C16.0674 17.2461 16.6397 17.009 17.0617 16.5871C17.4837 16.1651 17.7207 15.5928 17.7207 14.9961V2.62109C17.7207 2.02436 17.4837 1.45206 17.0617 1.0301C16.6397 0.608147 16.0674 0.371094 15.4707 0.371094ZM6.4707 6.55859H16.5957V10.4961H6.4707V6.55859ZM5.3457 10.4961H1.9707V6.55859H5.3457V10.4961ZM1.9707 14.9961V11.6211H5.3457V16.1211H3.0957C2.79733 16.1211 2.51119 16.0026 2.30021 15.7916C2.08923 15.5806 1.9707 15.2945 1.9707 14.9961ZM15.4707 16.1211H6.4707V11.6211H16.5957V14.9961C16.5957 15.2945 16.4772 15.5806 16.2662 15.7916C16.0552 16.0026 15.7691 16.1211 15.4707 16.1211Z",
    fill: "#212224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSelectedBudget);
export default __webpack_public_path__ + "static/media/tableSelectedBudget.6404dc53c4e56814cfdd289133ef17da.svg";
export { ForwardRef as ReactComponent };